/**
 * @generated SignedSource<<d729fbe86a3c65d7d0fa8cb98a29f213>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainFooter_todo$data = {
  readonly canChangeStatus: boolean;
  readonly id: string;
  readonly lastChangedStatusBy: {
    readonly name: string;
  } | null;
  readonly response: {
    readonly __typename: "TodoResponseImage";
  } | {
    readonly __typename: "TodoResponseNumber";
  } | {
    readonly __typename: "TodoResponseText";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly status: TodoStatus;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainFooterResponseImage_todo" | "TodoEditNewMainFooterResponseNumber_todo" | "TodoEditNewMainFooterResponseText_todo" | "TodoFooterCircleStatus_todo">;
  readonly " $fragmentType": "TodoEditNewMainFooter_todo";
};
export type TodoEditNewMainFooter_todo$key = {
  readonly " $data"?: TodoEditNewMainFooter_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainFooter_todo">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainFooter_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoFooterCircleStatus_todo"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "lastChangedStatusBy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canChangeStatus",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainFooterResponseImage_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainFooterResponseNumber_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainFooterResponseText_todo"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "TodoResponseNumber",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "TodoResponseImage",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "TodoResponseText",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "bf4e10de2a13672bc7ea0df2c9075353";

export default node;
